const ATTRIBUTION_KEY = "eco_bain_lead_attribution_v1";
const CONFIRMED_LEAD_KEY = "eco_bain_confirmed_lead_v1";
const CONFIRMATION_TTL_MS = 15 * 60 * 1000;

function readJson(key) {
  try {
    return JSON.parse(sessionStorage.getItem(key) || "null");
  } catch (error) {
    return null;
  }
}

function referrerSource(referrer) {
  if (!referrer) return "(direct)";
  try {
    return new URL(referrer).hostname;
  } catch (error) {
    return "referral";
  }
}

export function captureLeadAttribution() {
  if (typeof window === "undefined") return null;

  const existing = readJson(ATTRIBUTION_KEY);
  const params = new URLSearchParams(window.location.search);
  const hasUtm = ["utm_source", "utm_medium", "utm_campaign"].some((key) => params.has(key));

  if (existing && !hasUtm) return existing;

  const referrer = document.referrer || existing?.referrer || "(direct)";
  const attribution = {
    source: params.get("utm_source") || existing?.source || referrerSource(document.referrer),
    medium: params.get("utm_medium") || existing?.medium || (document.referrer ? "referral" : "(none)"),
    campaign: params.get("utm_campaign") || existing?.campaign || "(not set)",
    landingPage: existing?.landingPage || `${window.location.pathname}${window.location.search}`,
    referrer,
    capturedAt: new Date().toISOString(),
  };

  try {
    sessionStorage.setItem(ATTRIBUTION_KEY, JSON.stringify(attribution));
  } catch (error) {
    // Storage can be unavailable in strict privacy modes; form submission still works.
  }

  return attribution;
}

export function getLeadAttribution() {
  return readJson(ATTRIBUTION_KEY) || captureLeadAttribution();
}

export function markConfirmedLead() {
  const marker = {
    id:
      typeof crypto !== "undefined" && typeof crypto.randomUUID === "function"
        ? crypto.randomUUID()
        : `${Date.now()}-${Math.random().toString(16).slice(2)}`,
    confirmedAt: Date.now(),
  };

  try {
    sessionStorage.setItem(CONFIRMED_LEAD_KEY, JSON.stringify(marker));
  } catch (error) {
    return null;
  }
  return marker;
}

export const leadTrackingConfig = {
  confirmationKey: CONFIRMED_LEAD_KEY,
  confirmationTtlMs: CONFIRMATION_TTL_MS,
};
